import { render, staticRenderFns } from "./NewEmailNotification.vue?vue&type=template&id=594c4f08&scoped=true&"
import script from "./NewEmailNotification.vue?vue&type=script&lang=js&"
export * from "./NewEmailNotification.vue?vue&type=script&lang=js&"
import style0 from "./NewEmailNotification.vue?vue&type=style&index=0&id=594c4f08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c4f08",
  null
  
)

export default component.exports